function addOnCheckout(){
    const checkoutBtn = document.querySelector('.cart__ctas button[type="submit"]');
    document.body.addEventListener('click',(e)=>{
        if (e.target == checkoutBtn){
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            hulkappsCheckout($);
        }
    },true)
}

const hulkLoad = setInterval(function(){
    if (typeof is_draft_order === 'boolean' && document.readyState === 'complete' && hulkapps || typeof hulkapps === 'undefined'){
      clearInterval(hulkLoad);
      console.log('HulkPO Loaded');
      document.querySelector('.hulk-submit').removeAttribute('disabled');
      document.querySelector('.hulk-submit').classList.remove('hulk-submit');
      if (is_draft_order)addOnCheckout();
    }
  },100)